import { DropdownButtonType, List,ListItem,ListProps, SingleSelectDropdown } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import {classes,cssClass } from '~src/style';
import { FlowOutputStepInfo } from '~src/ts/models/FlowOutputStepInfo';

import { getConnectionCategory, getOutputStepIconFromConnectionCategory } from '../utils/FlowDataConnectionUtils';

const rootClass: string = 'FlowSubscriptionsOutputsDropdown';

const outputNameCellIcon = cssClass(rootClass, 'outputNameCellIcon', {
  flex: '0 0 auto',
  height: '25px'
});

const outputRowClass = cssClass(rootClass, 'outputRow', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
});

export interface FlowSubscriptionOutputsDropdownProps {
  readonly outputs: ReadonlyArray<FlowOutputStepInfo>;
  readonly disableDropdown: boolean;
  readonly value: string | null;
  readonly isOnlineEnvironment?: boolean;
  readonly onChange: (value: string) => void;
  readonly disableCSV: boolean;
}

function getOutputRow(icon: string, name: string): React.ReactNode {
  return (
    <div className={outputRowClass}>
      <div className={classes(outputNameCellIcon, icon)}/>
      <span>{name}</span>
    </div>
  );
}

const getList = (props: FlowSubscriptionOutputsDropdownProps): JSX.Element => {
  const items: ListItem[] = [];

  props.outputs.filter((output) => {
    if (props.isOnlineEnvironment) {
      // online only supports published datasources
      const isPublishedDatasource = getConnectionCategory(output.dataConnection) === 'tableau' ||
      getConnectionCategory(output.dataConnection) === 'tableausite';
      return isPublishedDatasource;
    } else {
      return true;
    }
  }).forEach((output) => {
      const connectionCategory = getConnectionCategory(output.dataConnection);
      const icon: string = getOutputStepIconFromConnectionCategory(connectionCategory);
      const isWriteToDbOutput: boolean = connectionCategory === 'external'; // unsupported output type for v1
      const isCSV: boolean = connectionCategory === 'file';
      const isDisabled = (props.disableCSV && isCSV) || props.disableDropdown || isWriteToDbOutput;
      items.push({value: output.id, disabled: isDisabled, content: getOutputRow(icon, output.name)});
  });

  const listProps: ListProps = {items: items};
  return <List {...listProps} />;
};


export const FlowSubscriptionOutputsDropdown: React.FC<FlowSubscriptionOutputsDropdownProps> = (props: FlowSubscriptionOutputsDropdownProps) => {
  if (props.outputs === null) {
    return null;
  }
  const list: JSX.Element = getList(props);

  return (
    <SingleSelectDropdown
      label={''}
      type={DropdownButtonType.Line}
      list={list}
      value={props.value}
      disabled={props.disableDropdown || props.outputs.length < 1}
      onChange={props.onChange}
      testId={'flow-subscription-outputs-dropdown'}
    >
      {props.outputs.length < 1 ? Messages.flowSubscriptionsNoOutputsAvailable() : props.value === null ? Messages.flowSubscriptionsSelectFlowOutput() : null}
    </SingleSelectDropdown>
  );
};
